import {
    GET_EXPENSE_REQUEST,
    GET_EXPENSE_SUCCESS,
    GET_EXPENSE_ERROR
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_EXPENSE_REQUEST:
            return {
                loading: true,
            };
        case GET_EXPENSE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_EXPENSE_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}